import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';

import { genHTMLContent } from '../MetiersSteps/helpers';
import MinCustomDialog from './MinCustomDialog';

const styles = {
  divContainer: {
    width: '100%'
  },
  subject: {
    margin: '5% 0'
  }
};

class MailDialogs extends Component {
  state = {
    body: this.props.defaultText.body,
    subject: this.props.defaultText.subject,
    isShowPreview: false
  };

  updateState = (name, value) => {
    this.setState({ [name]: value });
  }

  render() {
    const {
      callback,
      defaultText: { title, checked = [] },
      classes,
      children,
    } = this.props;
    const { body, subject } = this.state;
    return (
      <MinCustomDialog
        middle
        maxWidth={this.state.isShowPreview ? 'xl' : 'md'}
        open
        title={title}
        onClose={() => callback(false)}
        actions={[
          <Button disabled={!body} key={3} color="warning" onClick={() => {
            this.updateState('isShowPreview', !this.state.isShowPreview);
          }}>
            {this.state.isShowPreview ? 'Cacher la prev' : 'Prévisualiser'}
          </Button>,
          <Button key={2} color="secondary" onClick={() => callback(false)}>
            Fermer
          </Button>,
          <Button
            key={1}
            color="primary"
            onClick={() => callback(true, body, subject, checked)}
          >
            Envoyer
          </Button>,
        ]}
      >
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={this.state.isShowPreview ? 6 : 12}>
            <div className={classes.divContainer}>
              <TextField
                variant="standard"
                className={classes.subject}
                fullWidth
                onChange={e => this.updateState('subject', e.target.value)}
                value={subject}
                label="Objet du mail" />
              <TextField
                variant="standard"
                fullWidth
                onChange={e => this.updateState('body', e.target.value)}
                value={body}
                multiline={true}
                maxRows={40}
                label="Corps du mail" />
            </div>
          </Grid>
          {
            this.state.isShowPreview && body && (
              <Grid item xs={12} sm={6}>
                {genHTMLContent(
                  body.replace(/(\r\n|\n|\r)/gm, '<br />'),
                  false,
                  { minHeight: '100%', padding: 12 }
                )}
              </Grid>
            )
          }
        </Grid>
        {children}
      </MinCustomDialog>
    );
  }
}

MailDialogs.propTypes = {
  callback: PropTypes.func.isRequired,
  defaultText: PropTypes.object
};

export default withStyles(MailDialogs, styles);
